import React, { Component } from 'react';
import T from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash.get';
import Features from 'app/features';
import { selectShowFeatureFlags } from 'ducks/feature-flags';
import { selectHasFeature } from 'ducks/user';
import { fetchShow, deleteShow, selectShow } from 'ducks/shows';
import { clearChanges, selectChanges, addChange, removeChange } from 'ducks/changes';
import { getInvalidFields } from 'validation/show';
import { mergeShowChanges } from 'routes/show/util';
import SettingsGroupGeneral from './components/settings-group-general';
import SettingsGroupSharing from './components/settings-group-sharing-and-discovery';
import SettingsGroupRSS from './components/settings-group-rss';
import SettingsGroupDelete from './components/settings-group-delete';
import SettingsGroupAcastPlus from './components/settings-group-acast-plus';
import SettingsDistribution from './components/settings-group-distribution';
import TabNavigation from '../components/tab-navigation';
import ValidationErrors from '../components/validation-errors';
import { makeFieldMeta } from './fields';

class ShowSettings extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    this.props.clearChanges(this.props.params.showId);
  }

  componentWillUnmount() {
    this.props.clearChanges(this.props.params.showId);
  }

  handleChange(path, value) {
    const currentValue = get(this.props.show, path);
    const currentChange = get(this.props.changes, path);
    // If incoming value is different than current (saved) value
    // add a change.
    if (currentValue !== value) {
      this.props.addChange(this.props.params.showId, path, value);
      return;
    }

    // If the incoming value is the same as the current saved value
    // but we have a change in the store, remove it.
    if (currentChange !== undefined) {
      this.props.removeChange(this.props.params.showId, path);
    }
  }

  render() {
    const { show, changes, hasAcastAccess } = this.props;
    const showWithChanges = mergeShowChanges(show, changes);
    const fieldMetaFunction = makeFieldMeta(
      showWithChanges,
      changes,
      getInvalidFields(showWithChanges)
    );

    return (
      <>
        <ValidationErrors changes={changes} show={show} />
        {hasAcastAccess && <TabNavigation />}
        {showWithChanges && (
          <>
            <SettingsGroupGeneral
              show={showWithChanges}
              onChange={this.handleChange}
              metaFunc={fieldMetaFunction}
            />
            {this.props.hasAcastPlus && (
              <SettingsGroupAcastPlus
                show={showWithChanges}
                onChange={this.handleChange}
                metaFunc={fieldMetaFunction}
              />
            )}
            <SettingsDistribution show={showWithChanges} />
            <SettingsGroupSharing show={showWithChanges} />
            <SettingsGroupRSS
              show={showWithChanges}
              onChange={this.handleChange}
              metaFunc={fieldMetaFunction}
            />
            <SettingsGroupDelete
              show={showWithChanges}
              onDelete={() => this.props.deleteShow(this.props.params.showId)}
            />
          </>
        )}
      </>
    );
  }
}

ShowSettings.propTypes = {
  addChange: T.func,
  changes: T.object,
  clearChanges: T.func,
  deleteShow: T.func,
  fetchShow: T.func,
  hasAcastAccess: T.bool,
  hasAcastPlus: T.bool,
  params: T.object,
  show: T.object,
  removeChange: T.func,
};

const checkAcastPlusFeature = selectHasFeature(Features.AcastPlus);

export default connect(
  (state, { params }) => {
    const featureFlags = selectShowFeatureFlags(params.showId)(state);

    return {
      show: selectShow(params.showId)(state),
      changes: selectChanges(params.showId)(state),
      hasAcastPlus: checkAcastPlusFeature(state),
      hasAcastAccess: featureFlags.includes(Features.AcastAccess),
    };
  },
  { fetchShow, deleteShow, addChange, removeChange, clearChanges }
)(ShowSettings);
